module.exports = __webpack_public_path__ + "assets/img/title-9424d423.png";